export const MastercardIcon = () => {
	return (
		<div>
			<svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M19.3781 1.92421H11.5031V16.0758H19.3781V1.92421Z" fill="#FF5F00" />
				<path
					d="M12.0032 9C12.0019 7.6371 12.3108 6.29178 12.9063 5.06588C13.5019 3.83999 14.3685 2.76565 15.4406 1.9242C14.113 0.880613 12.5185 0.23162 10.8394 0.0514015C9.16027 -0.128817 7.46435 0.167006 5.94544 0.905069C4.42653 1.64313 3.14591 2.79366 2.24997 4.22513C1.35403 5.6566 0.878906 7.31127 0.878906 9C0.878906 10.6887 1.35403 12.3434 2.24997 13.7749C3.14591 15.2063 4.42653 16.3569 5.94544 17.0949C7.46435 17.833 9.16027 18.1288 10.8394 17.9486C12.5185 17.7684 14.113 17.1194 15.4406 16.0758C14.3685 15.2343 13.5019 14.16 12.9063 12.9341C12.3108 11.7082 12.0019 10.3629 12.0032 9Z"
					fill="#EB001B"
				/>
				<path
					d="M30.0019 9C30.002 10.6887 29.5269 12.3434 28.631 13.7748C27.7351 15.2063 26.4546 16.3568 24.9357 17.0949C23.4168 17.833 21.7209 18.1288 20.0418 17.9486C18.3628 17.7684 16.7683 17.1194 15.4406 16.0758C16.5118 15.2335 17.3778 14.159 17.9732 12.9333C18.5687 11.7076 18.8781 10.3627 18.8781 9C18.8781 7.63731 18.5687 6.29241 17.9732 5.06671C17.3778 3.84101 16.5118 2.7665 15.4406 1.9242C16.7683 0.880611 18.3628 0.231615 20.0418 0.0513991C21.7209 -0.128817 23.4168 0.167018 24.9357 0.90509C26.4546 1.64316 27.7351 2.79369 28.631 4.22516C29.5269 5.65663 30.002 7.31129 30.0019 9Z"
					fill="#F79E1B"
				/>
				<path
					d="M29.1433 14.5769V14.2872H29.2601V14.2282H28.9626V14.2872H29.0795V14.5769H29.1433ZM29.7209 14.5769V14.2276H29.6297L29.5248 14.4679L29.4199 14.2276H29.3286V14.5769H29.393V14.3134L29.4914 14.5406H29.5582L29.6566 14.3129V14.5769H29.7209Z"
					fill="#F79E1B"
				/>
			</svg>
		</div>
	);
};
